module.exports = __webpack_public_path__ + "img/lexprogress-author.d6255afd.jpg";